export const getServiceDescription = (row) =>
  String(row?.description ?? row?.Description ?? "").trim();

export const getPricingRowLabel = (row, isService) => {
  if (!isService) return row?.item;

  const item = String(row?.item ?? "").trim();
  const description = getServiceDescription(row);
  return description ? `${item} - ${description}` : item;
};
